module.exports = __webpack_public_path__ + "img/default.69dfa6a3.png";